module.exports = __webpack_public_path__ + "img/money-free.082dd5a7.svg";